export default "__VITE_ASSET__ClwD5m_0__"